import React from "react";
import { observer } from "mobx-react-lite";
import { Form } from "react-bootstrap";
import Col from "react-bootstrap/Col";
import FakeInput from "@edaz/edazkit/controls/FakeInput";
import { emptyValue } from "utils/emptyValue";
import type PaymentBankTransferDetailViewModel from "viewModels/finance/payments/bankTransfer/paymentBankTransferDetailViewModel";
import Section from "views/common/section";
import { FormLabelWithTooltip } from "controls/formLabelWithTooltip";

export interface IdentifiersInfoProps {
  vm: PaymentBankTransferDetailViewModel;
}

const IdentifiersInfo = observer((props: IdentifiersInfoProps) => {
  const { vm } = props;

  return (
    <Section title={vm.translate("identifiersInfoTitle")} context>
      <Form.Row>
        <Form.Group as={Col} sm={3}>
          <Form.Label>{vm.translate("variableSymbol")}</Form.Label>
          <FakeInput target={vm.item} property="variableSymbol" valueFormatter={value => value ?? emptyValue} />
        </Form.Group>
        <Form.Group as={Col} sm={3}>
          <FormLabelWithTooltip tooltipText={vm.translate("newVariableSymbolTooltip")}>
            {vm.translate("newVariableSymbol")}
          </FormLabelWithTooltip>
          <FakeInput target={vm.item} property="newVariableSymbol" valueFormatter={value => value ?? emptyValue} />
        </Form.Group>
        <Form.Group as={Col} sm={3}>
          <Form.Label>{vm.translate("constantSymbol")}</Form.Label>
          <FakeInput target={vm.item} property="constantSymbol" valueFormatter={value => value ?? emptyValue} />
        </Form.Group>
        <Form.Group as={Col} sm={3}>
          <Form.Label>{vm.translate("specificSymbol")}</Form.Label>
          <FakeInput target={vm.item} property="specificSymbol" valueFormatter={value => value ?? emptyValue} />
        </Form.Group>
      </Form.Row>
      <Form.Row>
        <Form.Group as={Col} sm={6}>
          <Form.Label>{vm.translate("bankTransactionId")}</Form.Label>
          <FakeInput target={vm.item} property="bankTransactionId" valueFormatter={value => value ?? emptyValue} />
        </Form.Group>
        <Form.Group as={Col} sm={6}>
          <Form.Label>{vm.translate("externalBankTransactionId")}</Form.Label>
          <FakeInput target={vm.item} property="externalBankTransactionId" valueFormatter={value => value ?? emptyValue} />
        </Form.Group>
      </Form.Row>
    </Section>
  );
});

export default IdentifiersInfo;
